// Set the refresh interval time to 30 seconds
export const INTERVAL_TIME = 30000;
export const emptyToken = {
  tokenId: '',
  token: '',
  expiration: new Date().toLocaleDateString(),
};
